import { forwardRef } from 'react';

type ButtonSize = 'xs' | 's' | 'm' | 'l' | 'xl';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outlined' | 'danger' | 'dangerOutline' | 'warning';
  size?: ButtonSize;
  fullWidth?: boolean;
  children: React.ReactNode;
}

const sizeClass: Record<ButtonSize, string> = {
  xs: 'btn_xs',
  s: 'btn_s',
  m: 'btn_m',
  l: 'btn_l',
  xl: 'btn_xl',
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'primary', size = 'm', fullWidth, className = '', type = 'button', children, ...props },
  ref
) {
  const variantClass =
    variant === 'primary'
      ? 'form__btn form__btn_submit'
      : variant === 'danger'
        ? 'form__btn form__btn_danger'
        : variant === 'dangerOutline'
          ? 'form__btn form__btn_outlined form__btn_outlined_danger'
          : variant === 'warning'
            ? 'form__btn form__btn_warning'
            : variant === 'outlined'
              ? 'form__btn form__btn_outlined'
              : 'form__btn form__btn_cancel';
  return (
    <button
      ref={ref}
      type={type}
      className={`${variantClass} ${sizeClass[size]} ${fullWidth ? 'form__btn_full' : ''} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
});
